import React from 'react';
import GameQuery from '../../query/GameQuery';
import ProductionFixedCosts from '../../components/ProductionFixedCosts';
import { Route } from 'react-router-dom';
import { PRODUCTIONFIXEDCOSTS } from '../../routes';

const ProductionFixedCostsRoute = () => (
	<GameQuery>
		{({ game }) => (
			<Route
				path={PRODUCTIONFIXEDCOSTS}
				render={props => <ProductionFixedCosts {...props} game={game} />}
			/>
		)}
	</GameQuery>
);

export default ProductionFixedCostsRoute;
